import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appScrollIntoView]',
    standalone: false
})
export class ScrollIntoViewDirective implements AfterViewInit {

  @Input() set delayedScroll(data: boolean) {
    if (!data) {
      return;
    }
    setTimeout(() => {
      this.scroll();
    }, 50);
  }

  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewInit() {
    this.scroll();
  }

  scroll() {
    if (this.elementRef.nativeElement.classList.contains('active')) {
      this.elementRef.nativeElement.scrollIntoView({block: 'end'});
    }
  }
}
